import { render, staticRenderFns } from "./OurOfferCard.vue?vue&type=template&id=7d85e98a&scoped=true&"
import script from "./OurOfferCard.vue?vue&type=script&lang=js&"
export * from "./OurOfferCard.vue?vue&type=script&lang=js&"
import style0 from "./OurOfferCard.vue?vue&type=style&index=0&id=7d85e98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85e98a",
  null
  
)

export default component.exports